const imageModifier = (url, settings = '200x200', filter = false) => {
  /*
  Settings must be a string with the params. Ex:
  For resizing settings= 200x200
  For grayscale settgins= grayscale()
  You can concatenate setting. Ex: settings= 200x200/grayscale()
  More options at https://thumbor.readthedocs.io/

  If filter is set to true, we return the image with fit-in filter
  */
  let replaced = `https://assets-img.primaverasound.com/${settings}/psweb/70l5rj0swjfgrztwgx6w_1652638440365.png/fit-in/${settings}/`;

  if (typeof url === 'string') {
    if (url.match(/\.gif/)) return url;
    if (filter) return url.replace('assets.primaverasound.com/', `assets-img.primaverasound.com/fit-in/${settings}/`);
    replaced = url.replace('assets.primaverasound.com/', `assets-img.primaverasound.com/${settings}/`);
  }


  return replaced;
};

export default imageModifier;
